/**
 * @author Martin Leonov <martin.leonov@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import TransitionsEnum from './transitions-enum';

class TransitionParser {
  /**
   * Naparsuje název animace.
   * @param {string | undefined} value Název animace.
   * @returns {TransitionsEnum | null} Pro známé hodnoty se vrátí položka z enumu, jinak null.
   */
  static parse(value) {
    switch (value) {
      case 'fadeIn':
        return TransitionsEnum.FadeIn;
      case 'pulse':
        return TransitionsEnum.Pulse;
      case 'slideInRight':
        return TransitionsEnum.SlideInRight;
      case 'zoomIn':
        return TransitionsEnum.ZoomIn;
      case '':
      case 'empty':
        return TransitionsEnum.Empty;
      default:
        return null;
    }
  }
}

export default TransitionParser;
